<template>
    <section>
        <div v-for="(parent,parIndex) in data" :key="parIndex">
            <div v-if="parent.childs.length" class="section-box">
                <h5 class="pm-sum-class"><span class="pm-preview-padding">{{parent.name}}({{parent.max_score}}分)</span></h5>
                <div v-for="(items,itemsIndex) in parent.childs" :key="items.id" class="assess-items-box">
                    <p class="pm-sum-class" v-if="items.childs">{{items.name}}({{items.max_score}}分)</p>
                    <ul class="section-ul-box" v-for="(item,itemIndex) in items.childs" :key="item.id">
                        <li v-if="item.logic_type==0">
                            <ul class="pm-section-alone">
                                <li><span>{{item.name}}({{item.max_score}}分):</span></li>
                                <li><span>{{item.data_name}}:</span><span class="pm-li-span-right">{{item.data}}</span></li>
                                <li>
                                    <span class="pm-li-span-left">实际得分:</span><span class="pm-li-span-right">{{item.score || '0'}}</span>
                                    <el-tooltip class="item" effect="dark" :content="importSelect.find(t => t.value == item.static_logic).label" placement="right">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </li>
                            </ul>
                        </li>
                        <li v-if="item.logic_type==1">
                            <ul class="pm-section-alone">
                                <li><span>{{item.name}}<span v-show="!(item.assess_type==1 && item.static_logic ==1 && item.logic_type == 1)">({{item.max_score}}分)</span>:</span></li>
                                <el-form :model="item" :ref="`form${itemsIndex}${itemIndex}`" label-width="auto" class="el-form-block">
                                    <li v-for="(par,index) in item.seleData" :key="par.value">
                                        <el-form-item
                                            class="assess-input"
                                            :prop="'seleData.' + index + '.assess'"
                                            :label="(item.assess_type==1 && item.static_logic ==1 && item.logic_type == 1) ? ' ' : par.label"
                                            :rules="[
                                               {required: !(item.assess_type==1 && item.static_logic ==1 && item.logic_type == 1) && !par.disabled, message: '不能为空', trigger: 'blur'},
                                               { validator: (rule, value, callback)=> validates(rule, value, callback,item.max_score,par.disabled,item), trigger: 'blur' }
                                            ]"
                                        >
                                        <el-input :disabled="par.disabled" v-model.trim="par['assess']" size="mini"></el-input>
                                        </el-form-item>
                                    </li>
                                </el-form>
                                <li v-show="!(item.assess_type==1 && item.static_logic ==1 && item.logic_type == 1)">
                                    <span class="pm-li-span-left">实际得分:</span><span class="pm-li-span-right">{{item.score}}</span>
                                    <el-tooltip class="item" effect="dark" :content="setScore(item)" placement="right">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </li>
                            </ul>
                        </li>
                        <li  v-if="item.logic_type==2">
                            <ul class="pm-section-alone">
                                <li><span  style="font-weight:500;margin-right:65px">{{item.name}}:</span></li>
                                <li class="assess-input"><span><el-input size="mini"></el-input></span></li>
                            </ul>
                        </li>
                    </ul>
                    <ul class="pm-section-alone" style="margin-left:10px;margin-bottom:10px" v-if="!items.childs && items.logic_type==0">
                        <li><span  style="font-weight:500">{{items.name}}({{items.max_score}}分):</span></li>
                        <li><span>{{items.data_name}}:</span><span class="pm-li-span-right">{{items.data}}</span></li>
                        <li>
                            <span class="pm-li-span-left">实际得分:</span><span class="pm-li-span-right">{{items.score || '0'}}</span>
                            <el-tooltip class="item" effect="dark" :content="importSelect.find(t => t.value == items.static_logic).label" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </li>
                    </ul>
                    <ul class="pm-section-alone" style="margin-left:10px;margin-bottom:10px" v-if="!items.childs && items.logic_type==1">
                        <li>
                            <span style="min-width: 120px;display: inline-block;font-weight:500">{{items.name}}
                                <span v-show="!(items.assess_type==1 && items.static_logic ==1 && items.logic_type == 1)">({{items.max_score}}分)</span>:
                            </span>
                        </li>
                        <el-form :model="items" :ref="`form${itemsIndex}`" label-width="auto" class="el-form-block">
                            <li v-for="(par,index) in items.seleData" :key="par.value">
                                <el-form-item
                                    class="assess-input"
                                    :prop="'seleData.' + index + '.assess'"
                                    :label="(items.assess_type==1 && items.static_logic ==1 && items.logic_type == 1) ? ' ' : par.label"
                                    :rules="[
                                        {required: !par.disabled, message: '不能为空', trigger: 'blur'},
                                        { validator: (rule, value, callback)=> validates(rule, value, callback,items.max_score,par.disabled,items), trigger: 'blur' }
                                    ]"
                                >
                                <el-input :disabled="par.disabled" v-model.trim="par['assess']" size="mini"></el-input>
                                </el-form-item>
                            </li>
                        </el-form>   
                        <li v-show="!(items.assess_type==1 && items.static_logic ==1 && items.logic_type == 1)">
                            <span class="pm-li-span-left">实际得分:</span><span class="pm-li-span-right">{{items.score}}</span>
                            <el-tooltip class="item" effect="dark" :content="setScore(items)" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </li>
                    </ul>
                    <ul class="pm-section-alone" style="margin-left:10px;margin-bottom:10px" v-if="!items.childs && items.logic_type==2">
                        <li><span  style="font-weight:500">{{items.name}}</span></li>
                        <li class="assess-input"><span><el-input size="mini"></el-input></span></li>
                    </ul>
                </div>
                <dl v-if="parent.name==='管理能力' && parent.childs.length>0 && myTeam" style="padding-left:0;margin-top:0">
                    <dt class="pm-sum-class" style="padding-top:0">全组成绩(5分) 
                        <el-button v-if="isExaminers && buttsele==='个人考核表'" type="primary" size="mini" style="margin-left:20px;" @click="visibleChange">详细数据</el-button>
                    </dt>
                    <dd><span>全组考勤({{myTeam.attendanceMaxScore}}分):</span><span  class="pm-dl-span">{{myTeam.attendanceAverageOfMyTeam}}</span>
                    <span class="pm-dl-span-left">全组时间管理({{myTeam.timeManageMaxScore}}分):</span><span  class="pm-dl-span">{{myTeam.timeManageAverageOfMyTeam}}</span>
                    <span class="pm-dl-span-left">全组工作达成({{myTeam.workAccomplishedMaxScore}}分):</span><span  class="pm-dl-span">{{myTeam.workAccomplishedAverageOfMyTeam}}</span>
                    <span class="pm-dl-span-left">全组工作能力({{myTeam.workAbilityMaxScore}}分):</span><span  class="pm-dl-span">{{myTeam.workAbilityAverageOfMyTeam}}</span>
                    <span class="pm-dl-span-left">全组管理能力({{myTeam.manageAbilityMaxScore}}分):</span><span  class="pm-dl-span">{{myTeam.manageAbilityAverageOfMyTeam}}</span>
                    <span class="pm-dl-span-left">实际得分:</span><span  class="pm-dl-span">{{myTeam.scoreOfMyTeam}}</span></dd>
                </dl>
                <p class="pm-sum-class pm-footer-p">总分:<span class="totalTxt">{{parent.score}}</span></p>
            </div>
        </div>
    </section>
</template>
<script>
import { tableSeleType,designFormulas } from '@/assets/js/message.js'
export default {
    data(){
        return {
            importSelect:[],
            pmData:[],
        }
    },
    created(){
        this.importSelect=designFormulas;
        this.pmData=tableSeleType;
    },
    computed:{
        
    },
    computed:{
        
    },
    methods:{
        submitForm(){
            let isValidate=true;
            for(let i in this.$refs){
                if(this.$refs[i].length>0){
                    this.$refs[i][0].validate((valid) => {
                        if (valid) {
                            isValidate=true;
                        } else {
                            console.log('error submit!!');
                            isValidate=false;
                        }
                    });
                }
                if (!isValidate) {
                    break;
                }
            }
            return isValidate;
        },
        resetForm(){                                         //重置表单
            for(let i in this.$refs){
                if(this.$refs[i].length>0){
                    this.$refs[i][0].resetFields();
                }
            }
        },
        validates(rule, value, callback,score,disabled, item){     //评价验证
            if(!disabled){
                if(isNaN(value)){
                    callback(new Error('请输入数字值'));
                }else if(value>score && !(item.assess_type==1 && item.static_logic ==1 && item.logic_type == 1)){ // 不计算类型不处理
                    callback(new Error(`超出最大值${score}`));
                }else if(value<0){
                    callback(new Error(`最小值须为0`));
                }else{
                    callback()
                }
            }else{
                callback()
            }
        },
        setScore(data){ //tooltip
            let score='';
            const assess_type=data.assess_type.split(',');
            const assess_percentage=data.assess_percentage.split(',');
            assess_type.map((item,index)=>{
                score+=` ${this.pmData.find(t=>t.value==item).label}${assess_percentage[index]}% +`
            })
            score=score.substring(0,score.length-1);
            return score;
        },
        visibleChange () {
            this.$emit('visibleChange',true)
        }
    },
    props:['data','myTeam','isExaminers','buttsele'],
}
</script>
<style scoped>
    .section-box{
        margin-bottom:10px;
        border: 1px solid #DCDFE6;
        border-radius: 6px 6px 0 0;
        width: 1080px;
        margin-left: 10px;
        font-size: 14px;
    }
    .section-box ul{
        margin: 0;
        padding: 0;
    }
    .section-box .section-ul-box{
        margin-bottom:10px;
        margin-left: 40px;
    }
    .section-box ul .pm-li-span-right{
        width:80px;
        border-bottom: 1px solid;
        display: inline-block;
        margin-left: 10px;
    }
    .section-box ul .pm-li-span-left{
        margin-left: 20px;
    }
    .pm-sum-class{
        padding: 10px;
        font-size: 14px;
        font-weight: 600;
    }
    .section-box>h5{
        border-bottom: 1px solid #DCDFE6;
    }
    .pm-footer-p{
        border-top: 1px solid #DCDFE6;
    }
    .pm-section-alone li{
        display: inline-block;
        margin-left: 20px;
        margin-top: 10px;
    }
    .pm-section-alone li .el-input{
        width:120px;
    }
    .pm-section-alone li:nth-child(1){
        margin: 0
    }
    .pm-dl-span{
        width:40px;
        border-bottom: 1px solid;
        display: inline-block;
        margin-left:5px;
    }
    .pm-dl-span-left{
        margin-left:10px;
    }
    .totalTxt{
        min-width: 80px; 
        display: inline-block;
        border-bottom: 1px solid #333;
    }
    .el-form-block{
        display: inline-block;
    }
    .el-form-item{
        margin: 0;
    }
    .assess-items-box{
        margin-bottom: 14px;
    }
</style>